import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface PlanLimitTooltipProps {
  children: React.ReactNode;
  enabled: boolean;
  planName: string;
  limitType: 'feature' | 'limit';
  featureName: string;
  currentCount?: number;
  maxCount?: number;
}

export function PlanLimitTooltip({ 
  children, 
  enabled, 
  planName, 
  limitType,
  featureName,
  currentCount,
  maxCount
}: PlanLimitTooltipProps) {
  if (enabled) {
    return <>{children}</>;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="cursor-not-allowed inline-block">
            {children}
          </span>
        </TooltipTrigger>
        <TooltipContent>
          {limitType === 'feature' ? (
            <>
              <p className="font-semibold">Função não ativa no plano {planName}</p>
              <p className="text-xs">
                {featureName} não está disponível no seu plano atual
              </p>
            </>
          ) : (
            <>
              <p className="font-semibold">Limite de {maxCount} {featureName} atingido</p>
              <p className="text-xs">
                Você já tem {currentCount} de {maxCount} {featureName} cadastrados no plano {planName}
              </p>
            </>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
